let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fTrd6")).then(() => parcelRequire('1bh7m'));